<h3 class="cb-margin-top">Lots to Cancel</h3>
<cb-table
    class="review-table cb-margin-top cb-margin-bottom flex"
    [stringColumns]="cancelledLotsColumns"
    [loaded]="true"
>
    <tbody cbTableBody>
        @for (lot of cancelledLots; track lot.id) {
            <tr cbTableRow>
                <cb-td-text [value]="lot.lotNumber"></cb-td-text>
                <cb-td-text [value]="LOT_TYPE_ENUM[lot.lotType]"></cb-td-text>
                <cb-td-text [value]="lot.jobNumber"></cb-td-text>
                <td>
                    {{ lot.lotAddress?.street }}
                    <br />
                    {{ lot.lotAddress?.suburb }}
                </td>
            </tr>
        } @empty {
            <tr>
                <td colspan="4">
                    <cb-info-message
                        message="No lots will be cancelled."
                        icon="info_circle"
                        iconClass="cb-accent"
                    ></cb-info-message>
                </td>
            </tr>
        }
    </tbody>
</cb-table>

<h3>New Lots to Create</h3>
<cb-table
    class="review-table cb-margin-top cb-margin-bottom flex"
    [stringColumns]="newLotsColumns"
    [loaded]="true"
>
    <tbody cbTableBody>
        @for (newLot of newLotSummaries; track $index) {
            <tr cbTableRow>
                <cb-td-text [value]="newLot.lotNumber"></cb-td-text>
                <cb-td-text [value]="newLot.lotType"></cb-td-text>
            </tr>
        } @empty {
            <tr>
                <td colspan="2">
                    <cb-info-message
                        message="No new lots configured."
                        icon="info_circle"
                        iconClass="cb-accent"
                    ></cb-info-message>
                </td>
            </tr>
        }
    </tbody>
</cb-table>

<h3>Document Migrations</h3>
@if (docAssignments.length === 0) {
    <cb-info-message
        class="cb-margin-bottom"
        message="No documents selected for migration."
        icon="info_circle"
        iconClass="cb-accent"
    ></cb-info-message>
} @else {
    @for (assignmentGroup of assignmentGroups; track assignmentGroup.destinationLotNumber) {
        <div class="cb-margin-bottom-2x">
            <h4 class="cb-margin-top">Destination Lot #{{ assignmentGroup.destinationLotNumber }}</h4>
            <cb-table
                class="review-table cb-margin-top cb-margin-bottom flex"
                [stringColumns]="documentMigrationColumns"
                [loaded]="true"
            >
                <tbody cbTableBody>
                    @for (assignment of assignmentGroup.assignments; track assignment.documentEntityId) {
                        <tr cbTableRow>
                            <cb-td-text [value]="assignment.documentName"></cb-td-text>
                            <cb-td-text [value]="assignment.documentType"></cb-td-text>
                            <cb-td-text [value]="assignment.sourceLotNumber"></cb-td-text>
                            <cb-td-text [value]="assignment.sourceJobNumber"></cb-td-text>
                        </tr>
                    }
                </tbody>
            </cb-table>
        </div>
    }
}
